//
//
//
//
//
//

import gameCont from '../game/index.vue'
export default {
  name: "Slot",
  components: {gameCont},
  data() {
    return {
      gameTypeCode: '1',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-1.vue